"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateHowToContent = exports.getDefaultChildContentBlock = exports.template = void 0;
var localization_1 = require("../../../components/localization");
var contentBlocks_1 = require("../../../utils/contentBlocks");
exports.template = "<div class=\"eg-content-editor\" data-type=\"howToItem\">{content}</div>";
var defaultChildContentBlocksCount = 3;
exports.getDefaultChildContentBlock = function (index) { return ({
    text: exports.template.replace('{content}', "Step " + (index + 1)),
    position: index,
    childContentBlocks: index === 0
        ? [
            {
                text: "<div class=\"eg-content-editor\" data-type=\"textEditorWithoutHeading\" style=\"width: 100%;\">\n              <div class=\"column\" style=\"display: inline-block; width: 100%; vertical-align: top;\">\n                <p>" + localization_1.localize('howToDescription') + "</p>\n                <p><strong>Tips:</strong></p>\n                <ul>\n                  <li>" + localization_1.localize('howToTipOne') + "</li>\n                  <li>" + localization_1.localize('howToTipTwo') + "</li>\n                  <li>" + localization_1.localize('howToTipThree') + "</li>\n                </ul>\n              </div>\n            </div>",
                position: 0
            }
        ]
        : []
}); };
var generateHowToContent = function (children) {
    if (children === void 0) { children = defaultChildContentBlocksCount; }
    return ({
        position: 0,
        text: contentBlocks_1.defaultTemplate('howToContent'),
        childContentBlocks: contentBlocks_1.getInitialContentBlocks(children, exports.getDefaultChildContentBlock)
    });
};
exports.generateHowToContent = generateHowToContent;
